import { getModule, Module, Mutation, VuexModule } from "vuex-module-decorators";
import store from "@/store";

interface ReadNotice {
  id: string;
  readAt: string;
}

interface IHospitalModule {
  _hospitalName: string;
  _hospitalId: string;
  _readNotices: ReadNotice[];
}

@Module({
  dynamic: true,
  store,
  name: "hospital",
  namespaced: true,
  preserveState: localStorage.getItem("vuex") && JSON.parse(localStorage.getItem("vuex") as string).hospital,
})
class HospitalModule extends VuexModule implements IHospitalModule {
  public _hospitalId = "";
  public _hospitalName = "";
  public _readNotices: ReadNotice[] = [];

  /**
   * 変更
   * @param name
   */
  @Mutation
  public changeHospitalName(name: string) {
    this._hospitalName = name;
  }
  /**
   * 変更
   * @param id
   */
  @Mutation
  public changeHospitalId(id: string) {
    this._hospitalId = id;
  }

  /**
   * お知らせを既読にする
   * @param id お知らせID
   */
  @Mutation
  public markNoticeAsRead(id: string) {
    // _readNoticesが初期化されていることを確認
    if (!this._readNotices) {
      this._readNotices = [];
    }

    const existingIndex = this._readNotices.findIndex((notice) => notice.id === id);
    const now = new Date().toISOString();

    if (existingIndex !== -1) {
      this._readNotices[existingIndex].readAt = now;
    } else {
      this._readNotices.push({
        id,
        readAt: now,
      });
    }
  }

  public get hospitalName() {
    return this._hospitalName || "";
  }
  public get hospitalId() {
    return this._hospitalId || "";
  }

  public get readNotices(): ReadNotice[] {
    return this._readNotices || [];
  }
}
export default getModule(HospitalModule);
